const navigateToName = (router, name, props = null) => {
  router.push({
    name: name,
    props: props
  })
}

export { navigateToName }
